import BackgroundAnimation from '../components/BackgroundAnimation';

// images
import featured_detailed_img_1 from '../../assets/images/feature-detailed-img-1.jpg';
import featured_detailed_img_2 from '../../assets/images/feature-detailed-img-2.jpg';
import featured_detailed_img_3 from '../../assets/images/feature-detailed-img-3.jpg';

const feature_tab = [
    {
        icon: "las la-comments",
        title: "Easy to Use",
        content: (
            <>
                <p className="paragraph-big">Bring all creature seas blessed whales were earth wherein evening dry one. Morning unto fly midst living so shall fish multiply meat day.</p>
                <div className="pattern-image">
                    <div className="pattern-image-wrapper">
                        <img className="drop-shadow-1" src={featured_detailed_img_1} height="470" alt="pattern" />
                        <div className="background-pattern background-pattern-radius drop-shadow-1">
                            <BackgroundAnimation/>
                            <div className="background-pattern-gradient"></div>
                        </div>
                    </div>
                </div>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
                <p>Our, that subdue open above creature i forth make and third beast bring had creeping stars brought together. Creepeth creature by open us our appear creeping bring they're darkness may which evening she'd thing days.</p>
                <h3 className="c-dark">Our unique promise.</h3>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
            </>
        )
    },
    {
        icon: "las la-headset",
        title: "Made for Everyone",
        content: (
            <>
                <p className="paragraph-big">Bring all creature seas blessed whales were earth wherein evening dry one. Morning unto fly midst living so shall fish multiply meat day.</p>
                <div className="pattern-image">
                    <div className="pattern-image-wrapper">
                        <img className="drop-shadow-1" src={featured_detailed_img_2} height="470" alt="pattern" />
                        <div className="background-pattern background-pattern-radius drop-shadow-1">
                            <BackgroundAnimation/>
                            <div className="background-pattern-gradient"></div>
                        </div>
                    </div>
                </div>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
                <p>Our, that subdue open above creature i forth make and third beast bring had creeping stars brought together. Creepeth creature by open us our appear creeping bring they're darkness may which evening she'd thing days.</p>
                <h3 className="c-dark">Our unique promise.</h3>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
            </>
        )
    },
    {
        icon: "las la-photo-video",
        title: "Share Everything",
        content: (
            <>
                <p className="paragraph-big">Bring all creature seas blessed whales were earth wherein evening dry one. Morning unto fly midst living so shall fish multiply meat day.</p>
                <div className="pattern-image">
                    <div className="pattern-image-wrapper">
                        <img className="drop-shadow-1" src={featured_detailed_img_3} height="470" alt="pattern" />
                        <div className="background-pattern background-pattern-radius drop-shadow-1">
                            <BackgroundAnimation/>
                            <div className="background-pattern-gradient"></div>
                        </div>
                    </div>
                </div>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
                <p>Our, that subdue open above creature i forth make and third beast bring had creeping stars brought together. Creepeth creature by open us our appear creeping bring they're darkness may which evening she'd thing days.</p>
                <h3 className="c-dark">Our unique promise.</h3>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
            </>
        )
    },
    {
        icon: "las la-server",
        title: "Unlimited Storage",
        content: (
            <>
                <p className="paragraph-big">Bring all creature seas blessed whales were earth wherein evening dry one. Morning unto fly midst living so shall fish multiply meat day.</p>
                <div className="pattern-image">
                    <div className="pattern-image-wrapper">
                        <img className="drop-shadow-1" src={featured_detailed_img_1} height="470" alt="pattern" />
                        <div className="background-pattern background-pattern-radius drop-shadow-1">
                            <BackgroundAnimation/>
                            <div className="background-pattern-gradient"></div>
                        </div>
                    </div>
                </div>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
                <p>Our, that subdue open above creature i forth make and third beast bring had creeping stars brought together. Creepeth creature by open us our appear creeping bring they're darkness may which evening she'd thing days.</p>
                <h3 className="c-dark">Our unique promise.</h3>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
            </>
        )
    },
    {
        icon: "las la-user-lock",
        title: "Data Protection",
        content: (
            <>
                <p className="paragraph-big">Bring all creature seas blessed whales were earth wherein evening dry one. Morning unto fly midst living so shall fish multiply meat day.</p>
                <div className="pattern-image">
                    <div className="pattern-image-wrapper">
                        <img className="drop-shadow-1" src={featured_detailed_img_2} height="470" alt="pattern" />
                        <div className="background-pattern background-pattern-radius drop-shadow-1">
                            <BackgroundAnimation/>
                            <div className="background-pattern-gradient"></div>
                        </div>
                    </div>
                </div>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
                <p>Our, that subdue open above creature i forth make and third beast bring had creeping stars brought together. Creepeth creature by open us our appear creeping bring they're darkness may which evening she'd thing days.</p>
                <h3 className="c-dark">Our unique promise.</h3>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
            </>
        )
    },
    {
        icon: "las la-map-marked-alt",
        title: "Use from Anywhere",
        content: (
            <>
                <p className="paragraph-big">Bring all creature seas blessed whales were earth wherein evening dry one. Morning unto fly midst living so shall fish multiply meat day.</p>
                <div className="pattern-image">
                    <div className="pattern-image-wrapper">
                        <img className="drop-shadow-1" src={featured_detailed_img_3} height="470" alt="pattern" />
                        <div className="background-pattern background-pattern-radius drop-shadow-1">
                            <BackgroundAnimation/>
                            <div className="background-pattern-gradient"></div>
                        </div>
                    </div>
                </div>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
                <p>Our, that subdue open above creature i forth make and third beast bring had creeping stars brought together. Creepeth creature by open us our appear creeping bring they're darkness may which evening she'd thing days.</p>
                <h3 className="c-dark">Our unique promise.</h3>
                <p>There grass said shall won't thing moved shall sea all male two is. Fowl man sixth gathering heaven was brought air fill dry further abundantly them be from won't every have cattle darkness moveth every the darkness may which evening she'd thing own man is there said gathering be the in lesser called.</p>
            </>
        )
    }
];

export default feature_tab;